import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const iconBack = css`
  position: relative;

  &:before {
    content: '';
    background-color: ${cssTheme.default.day.control};
    border-radius: 50%;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    inline-size: ${spacing(5)};
    block-size: ${spacing(5)};
  }
`
export const icon = css`
  position: relative;
`
